/**
 * Chat widget view for the question form shown by chatbot
 */
import springyView from '../../tools/SpringyView.js';
import { QuestionForm } from '../../public/QuestionForm.js';
import { focusFirst } from '../../tools/focusUtil.js';

const qformView = Object.create(springyView);

qformView.events = {
    keydown: 'trapFocus',
};

/**
 * Wrapper for springyView.init in case we need extra functionality.
 * @param {ChatWidget} model Widget object for this view.
 * @param {PatronSession} patronSession Current patron info
 * @param {SuiEventEmitter} emitter widget emitter
 */
qformView.initialize = function ({
    model,
    patronSession,
    emitter,
}) {
    this.patronSession = patronSession;
    this.emitter = emitter;
    this.init({
        model,
        el: document.getElementById('qform'),
    });
};
/**
 * Show this view and set focus as appopriate
 */
qformView.showView = function () {
    this.el.classList.remove('hidden');
    focusFirst(this.el);
};
/**
 * Render the view
 * @param {String} html Form html from php
 * @param {Object} errormsg Customized/localized error messages
 * @param {Object} translations Translaction keys/values
 * @param {Object} autoReplySettings Autoreply on/off/hours/etc.
 * @param {TicketAction} action Ticket action.
 * @param {Array<Object>} rules Field rules
 * @return {qformView}
 */
qformView.render = function ({
    html,
    errormsg,
    translations,
    autoReplySettings,
    action,
    rules,
}) {
    // clear out existing content, events, etc.
    this.$el.empty();
    this.el.innerHTML = html;

    this.questionform = new QuestionForm({
        form_action: `/chat/bot/session/${this.patronSession.getChannel()}/formticket`,
        queue_id: action.subType,
        errormsg,
        translations,
        autoReplySettings,
        rules,
    });
    this.questionform.setSuccessCallback(({ ticket_id = 0 }) => {
        this.emitter.trigger('changeView', 'chat');
        this.emitter.trigger('bot:ticket:success', { action, ticket_id });
    });
    this.questionform.setUp();
    this.questionform.setName(this.patronSession.get('name'));
    this.questionform.setEmail(this.patronSession.get('client_contact'));
    this.questionform.setLibraryCard(this.patronSession.get('local_id'));

    // if bot was authed set alt_auth_id"value, so form checks that Auth
    const authId = this.model.get('auth_id');
    if (authId > 0) {
        const authField = this.el.querySelector('input[name="alt_auth_id"]');
        if (authField) {
            authField.value = authId;
        }

        if (this.model.get('isAuthValidated')) {
            if (this.patronSession.get('name') != '') {
                this.el.querySelector('input[name="pemail"]')?.setAttribute('readonly', '');
            }
            if (this.patronSession.get('client_contact') != '') {
                this.el.querySelector('input[name="pname"]')?.setAttribute('readonly', '');
            }
            if (this.patronSession.get('local_id') != '') {
                this.el.querySelector('input[name="localid"]')?.setAttribute('readonly', '');
            }
        }
    }
    // Bot only cancel buttons
    this.el.querySelectorAll('.btn-cancel').forEach((el) => {
        el.addEventListener('click', () => {
            this.emitter.trigger('changeView', 'chat');
            this.emitter.trigger('bot:ticket:cancel', { action });
        });
    });

    return this;
};

export default qformView;
